import React from 'react';
import Helmet from 'react-helmet';

function SiteHelmet({
  title = '',
  favicon = null,
  faviconType = 'image/png',
  keywords = '',
  description = '',
  author = ''
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <link rel='icon' type={faviconType} href={favicon} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
    </Helmet>
  )
}

export default SiteHelmet